/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/featuresSection.config.json';
import { useProductQR } from '../provider';
import axios from 'axios';
import { toast } from 'react-hot-toast';

export interface IFeatureSectionMethods extends IPluginMethodMap {
  getFeatureSectionProps(args: any): Promise<any>;
}

export class FeatureSectionService implements IAgentPlugin {
  readonly methods: IFeatureSectionMethods;

  constructor() {
    this.methods = {
      getFeatureSectionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const id = useProductQR();
    console.log(`In service args: `, args, id);
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.fullProvenanceEP}`,
        {
          barcode: id,
          appMode: 'web',
          scanType: 'qrcode',
          userProfile: {
            username: args?.name,
            email: args?.email,
            phone: args?.phone,
            gender: args?.gender,
          },
          lat: args?.latitude,
          lon: args?.longitude,
        },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      if (res?.data) {
        return {
          ...res?.data?.data,
          skipped: args?.skipped ? args?.skipped : false,
        };
      }
    } catch (err: any) {
      console.log(`error in service :`, err);
      //toast.error(err?.response?.data?.error_message, { duration: 3000 });
      return false;
    }
  }
}
